class GlobalConstants {
  private static instance: GlobalConstants;
  private readonly constants: {
    fontFamily: string;
    isDarkTheme: boolean;
    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;
    highlighted_section: string;
    inactive: string;
  };

  private constructor({
    fontFamily,
    isDarkTheme,
    primaryColor,
    secondaryColor,
    tertiaryColor,
    highlighted_section,
    inactive,
  }: {
    fontFamily: string;
    isDarkTheme: boolean;
    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;
    highlighted_section: string;
    inactive: string;
  }) {
    this.constants = {
      fontFamily,
      isDarkTheme,
      primaryColor,
      secondaryColor,
      tertiaryColor,
      highlighted_section,
      inactive
    };
  }

  public static initialize({
    fontFamily,
    isDarkTheme,
    primaryColor,
    secondaryColor,
    tertiaryColor,
    highlighted_section,
    inactive
  }: {
    fontFamily: string;
    isDarkTheme: boolean;
    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;
    highlighted_section: string;
    inactive: string;
  }): void {
    if (!GlobalConstants.instance) {
      GlobalConstants.instance = new GlobalConstants({
        fontFamily,
        isDarkTheme,
        primaryColor,
        secondaryColor,
        tertiaryColor,
        highlighted_section,
        inactive
      });
    }
  }

  public static getInstance(): GlobalConstants {
    if (!GlobalConstants.instance) {
      throw new Error('GlobalConstants not initialized.');
    }
    return GlobalConstants.instance;
  }

  public getConstants(): {
    fontFamily: string;
    isDarkTheme: boolean;
    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;
    highlighted_section: string;
    inactive: string;
  } {
    return this.constants;
  }


  public updateTheme(isDarkTheme: boolean = false): void {
    if (!GlobalConstants.instance) {
      throw new Error('GlobalConstants not initialized.');
    };
    this.constants.isDarkTheme = isDarkTheme;
  }
}

export default GlobalConstants;
